import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Programarea',
        items: [
            'Vă programați telefonic, la +40 752 875 121, prin site sau la recepție.',
            'Programarea este confirmată după ce primiți confirmarea noastră. Cu o zi înainte vă reamintim, prin SMS sau telefon.',
            'Programul clinicii: luni – sâmbătă, 07:00 – 21:00. Programul fiecărui medic este afișat pe pagina lui.'
        ]
    },
    {
        title: 'Anularea, întârzierea, neprezentarea',
        items: [
            'Dacă nu puteți ajunge, anunțați-ne cu cel puțin 24 de ore înainte. Ora eliberată o dăm altui pacient.',
            'La o întârziere de peste 15 minute, consultația poate fi reprogramată, ca să nu întârzie pacienții care urmează.',
            'După două neprezentări neanunțate, programările următoare se fac numai telefonic, cu confirmare în ziua dinainte.'
        ]
    },
    {
        title: 'Ce aduceți',
        items: [
            'Actul de identitate. Pentru copii, actul de identitate al părintelui sau al reprezentantului legal și certificatul de naștere sau actul copilului.',
            'Biletul de trimitere, dacă aveți, analizele și investigațiile anterioare, scrisorile medicale și lista medicamentelor pe care le luați.'
        ]
    },
    {
        title: 'Copiii',
        text: 'Pacienții sub 18 ani vin însoțiți de un părinte sau de reprezentantul legal, care își dă acordul pentru actul medical. Excepțiile sunt doar cele prevăzute de lege.'
    },
    {
        title: 'Informarea și acordul',
        text: 'Medicul vă explică diagnosticul, investigațiile și tratamentul propus, cu beneficiile și riscurile lor. Pentru procedurile care o cer, acordul se dă în scris, pe formularul de consimțământ informat. Puteți refuza sau opri oricând un act medical; refuzul se consemnează în scris.'
    },
    {
        title: 'Prețul și plata',
        items: [
            'Prețurile sunt cele afișate pe site și la recepție. Pentru proceduri și pachete primiți înainte un deviz scris.',
            'Plata se face la recepție, după consultație, în numerar sau cu cardul. Primiți bon fiscal sau factură.',
            'Clinica nu are contract cu Casa de Asigurări de Sănătate; serviciile nu se decontează din fondurile CNAS.',
            'Analizele de laborator, investigațiile de radiologie și medicamentele din farmacie sunt servicii ale partenerilor din clădire, cu prețurile și documentele lor.'
        ]
    },
    {
        title: 'Rezultatele și documentele medicale',
        items: [
            'La finalul consultației primiți scrisoarea medicală sau recomandările scrise, iar rețetele și trimiterile, când este cazul.',
            'Puteți cere o copie a documentelor din dosarul dumneavoastră medical; o eliberăm în cel mult 15 zile lucrătoare.',
            'Documentele medicale se predau numai pacientului, reprezentantului legal sau persoanei desemnate în scris de pacient.'
        ]
    },
    {
        title: 'Reclamațiile',
        text: 'Dacă ceva nu a mers bine, spuneți-ne la recepție, scrieți-ne la contact@evoomedical.ro sau depuneți o sesizare scrisă. Răspundem în scris în cel mult 30 de zile. Vă puteți adresa oricând și DSP Alba, Colegiului Medicilor Alba sau ANPC.'
    },
    {
        title: 'Comportamentul în clinică',
        text: 'Vă rugăm să respectați programul, personalul și ceilalți pacienți. Fumatul, inclusiv țigara electronică, este interzis în clădire și în curte. Animalele de companie nu au acces în spațiile medicale, cu excepția câinilor însoțitori.'
    },
    {
        title: 'Temeiul',
        unnumbered: true,
        text: 'Legea nr. 46/2003 a drepturilor pacientului și normele ei de aplicare; Legea nr. 95/2006 privind reforma în domeniul sănătății; Ordonanța Guvernului nr. 21/1992 privind protecția consumatorilor; Codul civil.'
    }
];

function ConditiiGenerale() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Condițiile generale de prestare a serviciilor medicale"
            intro="Este partea din regulile clinicii care vă privește direct: cum vă programați, ce aduceți, cum plătiți și ce se întâmplă dacă nu puteți ajunge. Textul complet se poate consulta la recepție."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default ConditiiGenerale;
